
import React, { useEffect, useMemo } from 'react'
import { Container, Divider, Grid, Typography, makeStyles, Box, Tab, IconButton } from '@material-ui/core'
import AsterTabs from 'asterX-UI/Tabs/AsterTabs';
import AsterTab from 'asterX-UI/Tabs/AsterTab';
import { a11yProps } from 'asterX-UI/Tabs/TabPanel';
import { useTranslation } from 'react-i18next';
import { useHomeStore } from 'context/HomeStore';
import { ERROR_COLORS, GRAY_COLORS } from 'asterX-UI'
import { LoaderBackdrop } from 'asterX-UI/Loaders';
import { DeleteIcon } from '../../asterX-UI/Icons'
import { useRoutes } from '../../lib/hooks'
import { OnlineSigningInfo_PATH } from '../../routes/constants.routes'
import BookToolkipIcon from '../../asterX-UI/Icons/BookToolkipIcon'
import DocumentCards from './components/DocumentCards/DocumentCards';
import { Table } from './components/Table/Table';
import { EmptyLists } from './components/DocumentCards/EmptyLists/EmptyLists';











const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    color: GRAY_COLORS[900]
  },
  refusedTab: {
    borderColor: GRAY_COLORS[300],
    color: GRAY_COLORS[800],
    fontSize: 14,
    fontWeight: 600,
    boxShadow: 'none',
    border: `1px solid ${GRAY_COLORS[100]}`,
    borderRadius: 8,
    marginLeft: 8,
    '&.Mui-selected': {
      backgroundColor: ERROR_COLORS[50],
      fontWeight: 700,
      color: '#d32f2f'
    },
    '&:hover': {
      backgroundColor: ERROR_COLORS[50],
      color: '#d32f2f'
    }
  }
}));

const desktopTabs = {
  new: <Table />,
  at_signing: <Table />,
  signed: <Table />,
  refused: <Table />
};

const mobileTabs = {
  new: <DocumentCards />,
  at_signing: <DocumentCards />,
  signed: <DocumentCards />,
  refused: <DocumentCards />
};

const Home = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const {
    homeStore: { loading, selectedTab, isMobile, lists },
    homeStoreFunc: { onChangeTab,checkAndRedirectToContract }
  } = useHomeStore();
  const router = useRoutes()



  const configTabs = useMemo(
    () => [
      { label: t('home.new'), value: 'new' },
      { label: t('home.signed'), value: 'at_signing' },
      { label: t('home.signed_all'), value: 'signed' },
      { label: t('home.refused'), value: 'refused' }
    ],
    [t]
  );

  const renderContent = () => {
    const tabs = isMobile ? mobileTabs : desktopTabs;
    if (!lists || lists.length === 0) {
      return <EmptyLists selectedTab={selectedTab} />;
    }
    return tabs[selectedTab] || <EmptyLists />;
  };


  useEffect(() => {
    checkAndRedirectToContract(router)
  }, []);


  return (
    <Container className={classes.root} fullWidth>
      <LoaderBackdrop loading={loading} />
      <Grid container direction="column" xs={12} md={12} style={{ marginBottom: 10 }}>
        <Typography className={classes.title}>Онлайн подписание
          <IconButton onClick={()=>router.goTo(OnlineSigningInfo_PATH)}>
          <BookToolkipIcon></BookToolkipIcon>
        </IconButton></Typography>
      </Grid>

      <Grid item container direction="row" spacing={2}>
        <Grid item xs={12} md={12}>
          <AsterTabs value={selectedTab} onChange={onChangeTab} variant="scrollable" scrollButtons="auto">
            {configTabs
              .filter(tab => tab.value !== 'refused')
              .map(tab => (
                <AsterTab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  {...a11yProps(tab.value)}
                />
              ))}
            <Box sx={{ flexGrow: 1 }} />
            {configTabs
              .filter(tab => tab.value === 'refused')
              .map(tab => (
                <Tab
                  key={tab.value}
                  label={ <Box display="flex" alignItems="center" sx={{ gap: '8px' }}>
                    <DeleteIcon sx={{ color: GRAY_COLORS[600] }} />
                    {tab.label}
                  </Box>}
                  value={tab.value}
                  {...a11yProps(tab.value)}
                  className={classes.refusedTab}
                  disableRipple
                />
              ))}
          </AsterTabs>
          <Divider style={{ margin: '16px 0' }} />
          {renderContent()}
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;
